var _g, _defs;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var GooglePlayIso = function GooglePlayIso(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_g || (_g = /*#__PURE__*/_jsxs("g", {
      filter: "url(#filter0_ii)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M8.98125 7.40266C8.67878 7.7151 8.5 8.19998 8.5 8.82789V31.2622C8.5 31.8911 8.67878 32.375 8.98125 32.6874L9.05817 32.7604L21.9355 20.1931V20.045V19.8969L9.05817 7.32861L8.98125 7.40266Z",
        fill: "url(#paint0_linear)"
      }), /*#__PURE__*/_jsx("path", {
        d: "M26.2273 24.3837L21.9355 20.1932V20.0451V19.897L26.2283 15.7075L26.325 15.7613L31.4109 18.5813C32.8629 19.3867 32.8629 20.7044 31.4109 21.5109L26.325 24.3309L26.2273 24.3837Z",
        fill: "url(#paint1_linear)"
      }), /*#__PURE__*/_jsx("g", {
        filter: "url(#filter1_i)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M26.3247 24.3297L21.9342 20.0449L8.98096 32.6873C9.45909 33.1823 10.2501 33.2432 11.1409 32.7502L26.3247 24.3297Z",
          fill: "url(#paint2_linear)"
        })
      }), /*#__PURE__*/_jsx("path", {
        d: "M26.3247 15.7603L11.1409 7.34091C10.2501 6.8469 9.45909 6.90878 8.98096 7.4038L21.9352 20.0461L26.3247 15.7603Z",
        fill: "url(#paint3_linear)"
      })]
    })), _defs || (_defs = /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("filter", {
        id: "filter0_ii",
        x: "8.5",
        y: "7",
        width: "23.9999",
        height: "26.0907",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          "in": "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "-0.15"
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: "-1",
          k3: "1"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "shape",
          result: "effect1_innerShadow"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          "in": "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "0.15"
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: "-1",
          k3: "1"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect1_innerShadow",
          result: "effect2_innerShadow"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter1_i",
        x: "8.98096",
        y: "20.0449",
        width: "17.3437",
        height: "13.0458",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          "in": "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "-0.15"
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: "-1",
          k3: "1"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "shape",
          result: "effect1_innerShadow"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear",
        x1: "20.794",
        y1: "8.59052",
        x2: "3.77553",
        y2: "26.0288",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#00A0FF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.0066",
          stopColor: "#00A1FF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.2601",
          stopColor: "#00BEFF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.5122",
          stopColor: "#00D2FF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.7604",
          stopColor: "#00DFFF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#00E3FF"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint1_linear",
        x1: "33.301",
        y1: "20.0451",
        x2: "8.15143",
        y2: "20.0451",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#FFE000"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.4087",
          stopColor: "#FFBD00"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.7754",
          stopColor: "#FFA500"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#FF9C00"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint2_linear",
        x1: "23.9403",
        y1: "22.3718",
        x2: "0.86114",
        y2: "46.0204",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#FF3A44"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#C31162"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint3_linear",
        x1: "5.71865",
        y1: "-0.0643023",
        x2: "16.0241",
        y2: "10.4954",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#32A071"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.0685",
          stopColor: "#2DA771"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.4762",
          stopColor: "#15CF74"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.8009",
          stopColor: "#06E775"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#00F076"
        })]
      })]
    }))]
  });
};
export default GooglePlayIso;